var _path, _rect, _rect2, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGuides(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5934 6.82652C18.5934 9.5002 13.7523 13.6303 13.7523 13.6303C13.7523 13.6303 8.91113 9.5002 8.91113 6.82652C8.91113 4.15284 11.0786 1.9854 13.7523 1.9854C16.4259 1.9854 18.5934 4.15284 18.5934 6.82652Z",
    fill: "#A4FC67"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.307129,
    y: 13.6303,
    width: 6.28037,
    height: 19.3645,
    rx: 3.14019,
    transform: "rotate(-45 0.307129 13.6303)",
    fill: "#A4FC67",
    fillOpacity: 0.55
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 6.28037,
    height: 19.3645,
    rx: 3.14019,
    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 27.6929 13.6303)",
    fill: "#A4FC67",
    fillOpacity: 0.55
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9999 18.4414L16.2201 20.6617C17.4465 21.888 17.4465 23.8763 16.2201 25.1026C15.607 25.7157 14.8035 26.0223 13.9999 26.0223C13.1963 26.0223 12.3927 25.7157 11.7796 25.1026C10.5533 23.8763 10.5533 21.888 11.7796 20.6617L13.9999 18.4414Z",
    fill: "#A4FC67"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuides);
export default __webpack_public_path__ + "static/media/guides.7973691ce9cc56bb422c9af3c836cb58.svg";
export { ForwardRef as ReactComponent };